export const P5_VERSION = '1.4.0';
export const PREVIEW_WIDTH = 300;
export const HEIGHT = 300;
export const MAX_RUN_TIME = 1000;



// WEBPACK FOOTER //
// ./lib/defaults.ts